(function installCcmPersonalization() {
  if (customElements.get('ccm-personalization')) return;
  const schema = (properties = {}, required = []) => ({ type: 'object', properties, required, additionalProperties: false });
  const result = (value) => JSON.stringify(value);

  customElements.define('ccm-personalization', class extends HTMLElement {
    connectedCallback() {
      this.start = this.start.bind(this);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
      else this.start();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      this.controller?.abort();
      this.scope?.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('submit', this.onSubmit, true);
      this.unsubscribePhoto?.();
    }

    start() {
      if (!this.isConnected || this.started) return;
      this.scope = this.closest('product-info');
      this.form = document.getElementById(this.dataset.productFormId);
      if (!this.scope || !this.form) return;
      this.started = true;
      this.controller = new AbortController();
      this.onClick = (event) => {
        const button = event.target.closest('[data-ccm-photo-later]');
        if (!button || button.dataset.productFormId !== this.form.getAttribute('id')) return;
        event.preventDefault();
        const response = this.choosePhotoLater({ discardPhoto: true });
        const status = button.parentElement.querySelector('[data-ccm-photo-later-status]');
        if (status) { status.textContent = response.error || 'You can send your photo after purchase. Add your crystal to the cart when ready.'; status.hidden = false; }
      };
      this.onSubmit = (event) => {
        if (event.target !== this.form) return;
        if (this.importing) {
          event.preventDefault(); event.stopImmediatePropagation(); return;
        }
        if (this.importStatus === 'error') this.dismissImport();
        if (!this.checkProductionSelection()) {
          event.preventDefault(); event.stopImmediatePropagation(); return;
        }
        this.syncPhotoMode();
      };
      this.scope.addEventListener('click', this.onClick);
      this.scope.addEventListener('submit', this.onSubmit, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribePhoto = subscribe(PUB_SUB_EVENTS.filestackFileChoiced, ({ data }) => {
          if (!data?.url) { this.preview()?.resetAndOpen?.({ openPicker: false }); return; }
          this.clearPhotoLaterProperties();
          try { sessionStorage.removeItem(this.importStorageKey() + ':photo-later'); } catch (_error) {}
          const status = this.scope.querySelector('[data-ccm-photo-later-status]');
          if (status) { status.replaceChildren(); status.hidden = true; }
          if (this.importStatus === 'error') this.dismissImport();
        });
      }
      this.startImport();
      try { if (!this.importing && !this.hasPhoto() && sessionStorage.getItem(this.importStorageKey() + ':photo-later') === '1') this.choosePhotoLater(); } catch (_error) {}
      this.registerTools();
    }

    control(name) {
      return Array.from(this.form.elements).find((element) => element.name === name && element.type !== 'hidden')
        || Array.from(this.form.elements).find((element) => element.name === name);
    }

    productionSelection() {
      const base = this.bases().find((input) => input.checked);
      return {
        variant_id: this.control('id')?.value || '',
        base_variant_id: !base || base.dataset.baseSku === 'none' ? null : String(base.value),
        engraving_text: this.control('properties[Engrave Text]')?.value || '',
        font: this.control('properties[Font]')?.value || ''
      };
    }

    checkProductionSelection() {
      const preview = this.preview();
      if (!this.control('properties[_ccm_preview_source_ref]')?.value) return true;
      if (preview?.productionPhotoSelection && JSON.stringify(preview.productionPhotoSelection) === JSON.stringify(this.productionSelection())) return true;
      this.setImportStatus('configuration_changed', 'Your imported preview belongs to its original crystal, base, text and font. Restore those choices, create a new preview in your shopping chat, or choose a photo with the product uploader before adding to cart.');
      return false;
    }

    preview() { return this.scope.querySelector('ccm-live-preview-v3'); }
    bases() { return Array.from(this.scope.querySelectorAll('variant-selects-extended input[data-base-sku]')); }
    hasPhoto() { return Boolean(this.control('properties[Photo]')?.value || this.preview()?.file || this.preview()?.legacyPhoto?.url); }
    proof() { return this.scope.querySelector('[data-proof-preview-toggle]'); }
    clearPhotoLaterProperties() {
      this.form.querySelectorAll('[name="properties[Image submission]"], [name="properties[Photo submission]"]').forEach((input) => input.remove());
    }

    syncPhotoMode() {
      if (this.hasPhoto()) {
        this.clearPhotoLaterProperties();
        try { sessionStorage.removeItem(this.importStorageKey() + ':photo-later'); } catch (_error) {}
      }
    }

    state() {
      const text = this.control('properties[Engrave Text]');
      const font = this.control('properties[Font]');
      const proof = this.proof();
      return {
        product_id: this.scope.dataset.productId,
        import_status: this.importStatus || 'none',
        variant_id: this.control('id')?.value || '',
        crystal_sku: this.control('properties[Crystal SKU]')?.value || '',
        currency: this.dataset.currency,
        photo_attached: this.hasPhoto(),
        photo_later_selected: !this.hasPhoto() && (this.control('properties[Image submission]') || this.control('properties[Photo submission]'))?.value === 'After purchase',
        engraving: text ? { text: text.value, maximum_characters: Number(text.dataset.maxlength) || text.maxLength || 40, font: font?.value || '', fonts: Array.from(font?.options || []).map((option) => option.value) } : null,
        proof: proof ? { requested: proof.checked, policy: proof.closest('.proof-preview')?.querySelector('.proof-preview__text')?.textContent.trim() || '' } : null,
        light_bases: this.bases().filter((input) => !input.closest('.extended-hidden')).map((input) => ({ variant_id: input.value, sku: input.dataset.baseSku, name: input.dataset.productTitle, price_cents: Number(input.dataset.productPriceCents), available: !input.disabled, selected: input.checked })),
        delivery: 'Photo submission and any requested proof review affect timing. Delivery dates are shown at checkout.'
      };
    }

    choosePhotoLater({ discardPhoto = false } = {}) {
      if (!this.scope.querySelector('[data-ccm-photo-later]')) return { error: 'This product does not offer photo-later ordering.' };
      if (this.hasPhoto() && !discardPhoto) return { error: 'A photo is already attached. Use the visible Send photo later control to remove it, or keep your photo.' };
      if (discardPhoto) {
        this.preview()?.resetAndOpen?.({ openPicker: false });
        ['Photo', '_Photo', '_preview_image_url', '_preview_image_thumbnail_url', '_live_preview_v3_session_id', '_ccm_preview_source_ref'].forEach((name) => this.control(`properties[${name}]`)?.remove());
        this.scope.dispatchEvent(new CustomEvent('ccm:photo-later-selected', { detail: { formId: this.form.getAttribute('id') }, bubbles: true }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.filestackFileChoiced, { data: null, formId: this.form.getAttribute('id') });
      }
      if (this.importStatus === 'error') this.dismissImport();
      this.clearPhotoLaterProperties();
      // The legacy checkout app treats names containing Photo as image URLs.
      // Keep this public instruction separate from the actual Photo property.
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Image submission]';
      input.value = 'After purchase';
      this.form.append(input);
      try { sessionStorage.setItem(this.importStorageKey() + ':photo-later', '1'); } catch (_error) {}
      const status = this.scope.querySelector('[data-ccm-photo-later-status]');
      if (status) { status.textContent = 'You can send your photo after purchase. Add your crystal to the cart when ready.'; status.hidden = false; }
      return this.state();
    }

    setEngraving({ text, font }) {
      const input = this.control('properties[Engrave Text]');
      const select = this.control('properties[Font]');
      const maximum = Number(input?.dataset.maxlength) || 40;
      if (!input || !select) return { error: 'Engraving text is unavailable on this product.' };
      if (text !== undefined && (typeof text !== 'string' || text.length > maximum)) return { error: `Use at most ${maximum} characters.` };
      if (font !== undefined && !Array.from(select.options).some((option) => option.value === font)) return { error: 'Choose a font listed in ccm_get_personalization.' };
      if (text !== undefined) {
        input.value = text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (font !== undefined) {
        select.value = font;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return this.state();
    }

    requestProof({ requested }) {
      const checkbox = this.proof();
      if (!checkbox || typeof requested !== 'boolean') return { error: 'This product must offer a proof, and requested must be true or false.' };
      checkbox.checked = requested;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      return this.state();
    }

    selectBase({ variant_id }) {
      const input = this.bases().find((candidate) => candidate.value === String(variant_id));
      if (!input || input.disabled || input.closest('.extended-hidden')) return { error: 'Choose an available compatible base listed in ccm_get_personalization.' };
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return this.state();
    }

    previewState() {
      const preview = this.preview();
      return {
        active: Boolean(preview?.isActive),
        status: preview?.statusValue || (this.hasPhoto() ? 'photo_attached' : 'awaiting_photo'),
        stage: preview?.statusHeading?.textContent || '',
        message: preview?.statusBody?.textContent || '',
        illustration_only: true,
        designer_proof_requested: Boolean(this.proof()?.checked)
      };
    }

    openPhotoPicker() {
      const preview = this.preview();
      if (preview?.isActive) preview.openFilePicker();
      else {
        const button = this.scope.querySelector('.product-upload-photo .upload-controls button');
        if (!button) return { error: 'The photo picker is unavailable for this product.' };
        button.click();
      }
      return { status: 'awaiting_customer_photo_selection', message: 'Select an authorized photo in the uploader. The existing supported preview starts after selection.' };
    }

    addConfiguredCrystal() {
      const host = this.form.closest('product-form');
      const button = host?.submitButton;
      if (this.importing) return Promise.resolve({ error: 'Your preview is being restored. Please wait before adding to cart.' });
      if (this.importStatus === 'error') this.dismissImport();
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || this.cartPending) return Promise.resolve({ error: 'The product is unavailable or a cart submission is still in progress. Check the cart before retrying.' });
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return Promise.resolve({ error: 'Use the visible Add to Cart control.' });
      if (!this.checkProductionSelection()) return Promise.resolve({ error: 'The imported artwork no longer matches these choices. Restore the original choices or choose a new photo before adding to cart.' });
      const variant = this.control('id')?.value;
      this.cartPending = true;
      return new Promise((resolve) => {
        const unsubscribe = [];
        let timer;
        const finish = (payload) => {
          clearTimeout(timer);
          unsubscribe.forEach((stop) => stop());
          this.cartPending = false;
          resolve(payload);
        };
        unsubscribe.push(subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'product-form' || String(event.productVariantId) !== String(variant)) return;
          finish({ status: 'added_to_cart', variant_id: variant, message: 'The configured crystal was added through the product form. Review the cart before checkout.' });
        }));
        unsubscribe.push(subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source !== 'product-form' || String(event.productVariantId) !== String(variant)) return;
          finish({ error: event.message || 'The cart rejected this configuration. Review the product page.' });
        }));
        timer = setTimeout(() => finish({ status: 'uncertain', message: 'Cart submission has not been confirmed. Open the cart and check it; do not automatically submit again.' }), 55000);
        this.syncPhotoMode();
        try { this.form.requestSubmit(button); }
        catch (_error) { finish({ error: 'The product form could not be submitted. Use the visible Add to Cart control.' }); }
      });
    }

    importStorageKey() { return `ccm-agentic-import-v1:${window.location.pathname}`; }

    dismissImport({ resetArtwork = false } = {}) {
      if (this.importing) return;
      if (resetArtwork && this.control('properties[_ccm_preview_source_ref]')?.value) {
        this.preview()?.resetAndOpen?.({ openPicker: false });
      }
      this.pendingImport = null;
      this.importStatus = 'none';
      try { sessionStorage.removeItem(this.importStorageKey()); } catch (_error) {}
      this.scope.querySelector('[data-ccm-import-status]')?.remove();
    }

    setImportStatus(status, message) {
      this.importStatus = status;
      let panel = this.scope.querySelector('[data-ccm-import-status]');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'ccm-import-notice';
        panel.dataset.ccmImportStatus = '';
        const copy = document.createElement('p');
        copy.setAttribute('role', 'status');
        copy.setAttribute('aria-live', 'polite');
        const retry = document.createElement('button');
        retry.type = 'button'; retry.className = 'ccm-personalization__button'; retry.textContent = 'Retry restoring preview';
        retry.dataset.ccmImportRetry = '';
        retry.addEventListener('click', () => this.importConfiguration());
        const continueButton = document.createElement('button');
        continueButton.type = 'button'; continueButton.className = 'ccm-personalization__button';
        continueButton.textContent = 'Use the options below';
        continueButton.dataset.ccmImportContinue = '';
        continueButton.addEventListener('click', () => {
          if (this.importing) return;
          this.dismissImport({ resetArtwork: true });
        });
        const separator = document.createElement('span'); separator.textContent = ' '; separator.dataset.ccmImportSeparator = '';
        panel.append(copy, retry, separator, continueButton);
        (this.scope.querySelector('.product-upload-photo') || this.scope.querySelector('.main-content') || this.scope).append(panel);
      }
      panel.querySelector('[role="status"]').textContent = message;
      panel.querySelector('[data-ccm-import-retry]').hidden = status !== 'error';
      const continueButton = panel.querySelector('[data-ccm-import-continue]');
      continueButton.hidden = status !== 'error' && status !== 'configuration_changed';
      continueButton.textContent = status === 'configuration_changed' ? 'Discard imported preview' : 'Use the options below';
      panel.querySelector('[data-ccm-import-separator]').hidden = status !== 'error';
    }

    startImport() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get('ccm_preview_handoff');
      if (code !== null) {
        url.searchParams.delete('ccm_preview_handoff');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      }
      try {
        const stored = JSON.parse(sessionStorage.getItem(this.importStorageKey()) || 'null');
        if (code && /^[A-Za-z0-9_-]{43}$/.test(code)) {
          if (stored?.handoff_code === code && /^[A-Za-z0-9_-]{43}$/.test(stored.owner_context || '')) this.pendingImport = stored;
          else {
            const bytes = window.crypto.getRandomValues(new Uint8Array(32));
            const owner = window.btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            this.pendingImport = { handoff_code: code, owner_context: owner };
          }
          sessionStorage.setItem(this.importStorageKey(), JSON.stringify(this.pendingImport));
        } else if (code !== null) {
          this.setImportStatus('error', 'This preview link is invalid. Continue with the product controls or reopen your private preview link.');
          return;
        } else {
          // A normal visit must not retry an earlier private link or block purchasing.
          this.dismissImport();
        }
      } catch (_error) {
        if (code !== null) this.setImportStatus('error', 'Private browser storage is required to restore this preview safely. Enable it and reopen your preview link, or continue with the product controls.');
        return;
      }
      if (this.pendingImport) this.importConfiguration();
    }

    canonicalCrystalSku(sku) {
      const value = String(sku || '').trim().toUpperCase();
      const suffix = '(?:CUSTM|CUSTOM|SALE|PETS|MEMRL|JBCUS)';
      const rectangle = value.match(new RegExp('^(SCRT(?:0601|0801|1001|1201|1501|1801|2001))-(T|B)(?:-' + suffix + ')?$'));
      if (rectangle) return rectangle[1] + '-' + rectangle[2];
      const shape = '(?:SCHR(?:0801|1001)|SCSQ(?:0601|0801|1001)|SCPR1301|KCRT0301|NLRT0401|WSRT0501)';
      if (new RegExp('^' + shape + '$').test(value)) return value;
      const storefrontShape = value.match(new RegExp('^(' + shape + ')(?:-[A-Z0-9]+)?-' + suffix + '$'));
      return storefrontShape ? storefrontShape[1] : null;
    }

    canonicalBaseSku(sku) {
      const value = String(sku || '');
      const aliases = { LBBR0701: 'LBBR0702', LBBR1101: 'LBBR1102', LBBR1601: 'LBBR1602', LBBR2101: 'LBBR2102', LBRD0801: 'LBRD1101' };
      if (aliases[value]) return aliases[value];
      return ['none', 'LBBR0702', 'LBBR1102', 'LBBR1602', 'LBBR2102', 'LBWG0802', 'LBWG1102', 'LBWG1602', 'LBRD1101'].includes(value) ? value : null;
    }

    validateImport(payload) {
      const fail = () => { throw new Error('The imported configuration does not match the product controls.'); };
      if (payload?.schema !== 'ccm-preview-import.v1' || !['preview', 'later'].includes(payload.photo_mode)) fail();
      if (String(payload.variant?.variant_id) !== this.control('id')?.value) fail();
      const productUrl = new URL(payload.variant?.product_url || '', window.location.origin);
      if (productUrl.origin !== window.location.origin || productUrl.pathname !== window.location.pathname) fail();
      const selection = payload.selection;
      const crystalSku = this.canonicalCrystalSku(this.control('properties[Crystal SKU]')?.value);
      if (!crystalSku || !selection || selection.crystal_sku !== crystalSku || payload.variant?.crystal_sku !== crystalSku) fail();
      const input = this.control('properties[Engrave Text]');
      const font = this.control('properties[Font]');
      if (typeof selection.engraving_text !== 'string' || selection.engraving_text.length > (Number(input?.dataset.maxlength) || 40)) fail();
      if (selection.engraving_text && !input) fail();
      if (font && !Array.from(font.options).some((option) => option.value === selection.engraving_font)) fail();
      if (typeof payload.proof_requested !== 'boolean' || (payload.proof_requested && !this.proof())) fail();
      const base = this.bases().find((candidate) => payload.base_variant
        ? candidate.value === String(payload.base_variant.variant_id) && this.canonicalBaseSku(candidate.dataset.baseSku) === selection.base_sku
        : candidate.dataset.baseSku === 'none' && selection.base_sku === 'none');
      if (payload.base_variant && (!base || base.disabled || base.closest('.extended-hidden') || this.canonicalBaseSku(payload.base_variant.base_sku) !== selection.base_sku)) fail();
      if (!payload.base_variant && selection.base_sku !== 'none') fail();
      if (!payload.base_variant && base && (base.disabled || base.closest('.extended-hidden'))) fail();
      if (payload.photo_mode === 'later') {
        if (payload.production_photo_ref != null || payload.preview !== null || !this.scope.querySelector('[data-ccm-photo-later]')) fail();
      } else {
        if (!/^[A-Za-z0-9_-]{43}$/.test(payload.production_photo_ref || '')) fail();
        const preview = payload.preview;
        if (!this.preview()?.isActive || !preview || preview.status !== 'ready' || typeof preview.preview_token !== 'string' || !preview.preview_token || preview.preview_token.length > 4096) fail();
        if (!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(preview.session_id || '')) fail();
        if (!Number.isInteger(preview.compilation_revision) || preview.compilation_revision < 0) fail();
        if (preview.crystal_sku !== selection.crystal_sku || preview.base_sku !== selection.base_sku) fail();
        const prefix = `/apps/crystal-settings/api/v3/previews/${preview.session_id}`;
        for (const name of ['status_path', 'configure_path', 'cart_association_path', 'renderer_path', 'poster_path', 'client_event_path']) {
          if (typeof preview[name] !== 'string') fail();
          const url = new URL(preview[name], window.location.origin);
          if (url.origin !== window.location.origin || !(url.pathname === prefix || url.pathname.startsWith(prefix + '/'))) fail();
        }
      }
      return base;
    }

    async importConfiguration() {
      if (!this.pendingImport || this.importing) return;
      this.importing = true;
      this.setImportStatus('pending', 'Restoring your private crystal preview and personalization…');
      const controls = Array.from(this.scope.querySelectorAll('input, select, textarea, button'));
      const originalVariant = this.control('id')?.value;
      const disabled = new Map(controls.map((control) => [control, control.disabled]));
      controls.forEach((control) => { control.disabled = true; });
      const preview = this.preview();
      const wasRestoring = preview?.restoringCartEdit;
      if (preview) preview.restoringCartEdit = true;
      try {
        const payload = await window.StorefrontRequest.json('/apps/crystal-settings/api/v3/previews/import?preview_v3=1', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...this.pendingImport, variant_id: originalVariant })
        }, { timeoutMs: 30000 });
        // Validate against each option's original availability before making any change.
        controls.forEach((control) => { control.disabled = disabled.get(control); });
        if (!this.isConnected || this.control('id')?.value !== originalVariant) throw new Error('The product changed during import.');
        const base = this.validateImport(payload);
        if (payload.photo_mode === 'later' && this.hasPhoto()) throw new Error('A photo is already attached.');
        if (base) this.selectBase({ variant_id: base.value });
        if (this.control('properties[Engrave Text]')) this.setEngraving({ text: payload.selection.engraving_text, font: payload.selection.engraving_font });
        if (this.proof()) this.requestProof({ requested: payload.proof_requested });
        if (payload.photo_mode === 'later') {
          preview?.clearLineProperties?.();
          this.choosePhotoLater();
        }
        else {
          preview.stopPolling();
          preview.createAbortController?.abort();
          window.clearTimeout(preview.configureTimer);
          window.clearTimeout(preview.textTimer);
          preview.clearLineProperties();
          const state = payload.preview;
          const selection = { crystal_sku: this.control('properties[Crystal SKU]').value, base_sku: base?.dataset.baseSku || 'none', engraving_text: payload.selection.engraving_text, engraving_font: payload.selection.engraving_font, orientation: preview.dataset.defaultOrientation || 'tower' };
          preview.applyHandoffRecord({
            sessionId: state.session_id, previewToken: state.preview_token,
            productionPhotoRef: payload.production_photo_ref, productionPhotoSelection: this.productionSelection(),
            statusPath: state.status_path, configurePath: state.configure_path,
            cartAssociationPath: state.cart_association_path, rendererPath: state.renderer_path,
            posterPath: state.poster_path, clientEventPath: state.client_event_path,
            status: state.status, inferenceStatus: state.inference_status,
            compilationRevision: state.compilation_revision, selection,
            sentSelectionSignature: preview.selectionSignature(selection),
            appearanceVersion: state.poster?.appearance_version,
            posterFullUrl: state.poster?.full?.url || state.poster?.poster_url || '', posterThumbnailUrl: state.poster?.thumbnail?.url || state.poster?.thumbnail_url || state.poster?.full?.url || state.poster?.poster_url || ''
          });
          preview.productionPhotoRef = payload.production_photo_ref;
          preview.productionPhotoSelection = this.productionSelection();
          preview.setLineProperty('_ccm_preview_source_ref', payload.production_photo_ref, true);
          preview.setLineProperty('_live_preview_v3_session_id', state.session_id, true);
          preview.persistHandoff();
          this.syncPhotoMode();
        }
        try { sessionStorage.removeItem(this.importStorageKey()); } catch (_error) {}
        this.pendingImport = null;
        this.setImportStatus('restored', 'Your preview and choices are restored. Review your crystal, text, proof and base, then add it to your cart.');
      } catch (_error) {
        // Never log the one-time code, owner secret, preview token or server response.
        this.setImportStatus('error', 'Your preview could not be restored. You can still choose your photo and options below, or reopen your preview link.');
      } finally {
        this.importing = false;
        if (preview) preview.restoringCartEdit = wasRestoring;
        controls.forEach((control) => { if (control.isConnected) control.disabled = disabled.get(control); });
      }
    }

    async registerTools() {
      const context = document.modelContext;
      if (!context?.registerTool) return;
      const definitions = [
        ['ccm_get_personalization', 'Read the current CCM crystal configuration, engraving limits, exact proof policy and compatible bases.', schema(), () => this.state(), true],
        ['ccm_choose_photo_later', 'Select photo submission after purchase for the visible crystal with no attached photo. Updates its cart property without discarding existing artwork.', schema(), () => this.choosePhotoLater()],
        ['ccm_set_engraving', 'Set the visible engraving text and/or font for this crystal; updates the same form and preview as shopper input.', schema({ text: { type: 'string', description: 'Customer-approved engraving text within the product limit.' }, font: { type: 'string', description: 'Exact font name from ccm_get_personalization.' } }), (input) => this.setEngraving(input)],
        ['ccm_request_proof', 'Select or deselect the optional designer proof on this crystal. Read the five-day auto-approval policy first; a proof may delay shipping.', schema({ requested: { type: 'boolean', description: 'Whether the customer requests the optional proof.' } }, ['requested']), (input) => this.requestProof(input)],
        ['ccm_select_light_base', 'Select an available compatible optional light base for the currently selected crystal size. Changes the visible option and associated cart item.', schema({ variant_id: { type: 'string', description: 'Exact compatible base variant ID from ccm_get_personalization.' } }, ['variant_id']), (input) => this.selectBase(input)],
        ['ccm_open_photo_picker', 'Open the existing uploader for the customer to choose an authorized photo. A supported instant preview starts after selection. Does not accept arbitrary remote photo URLs.', schema(), () => this.openPhotoPicker()],
        ['ccm_get_preview', 'Inspect the existing instant preview status once. Does not create or retry a preview. An instant preview is illustrative, separate from a designer proof.', schema(), () => this.previewState(), true],
        ['ccm_add_configured_crystal', 'Add the visible configured crystal and selected accessories through the existing product form, preserving photo, engraving and proof properties. Changes the cart only; does not pay or place an order. Check the cart before any retry.', schema(), () => this.addConfiguredCrystal()]
      ];
      for (const [name, description, inputSchema, execute, readOnly = false] of definitions) {
        try {
          await context.registerTool({ name, description, inputSchema, annotations: { readOnlyHint: readOnly, untrustedContentHint: true }, execute: async (input = {}) => {
            if (!readOnly && this.importing) return result({ error: 'Your preview is being restored. Please wait before changing this configuration.' });
            if (!readOnly && this.importStatus === 'error') this.dismissImport();
            return result(await execute(input));
          } }, { signal: this.controller.signal });
        } catch (_error) {
          // WebMCP is progressive enhancement. Never replace Shopify's tools or break ordinary controls.
        }
      }
    }
  });
})();
